import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  DataResponseWithPagination,
  SupportConversationQuestionsResponseDataSchema,
  SupportSchema,
} from "schema"
import { z } from "zod"

type Query = z.input<typeof SupportSchema>
type Response = DataResponseWithPagination<
  z.infer<typeof SupportConversationQuestionsResponseDataSchema>
>

const getConversationQuestionsQueryKey = (query?: Query) => ["conversationQuestions", query]

type Props = {
  query?: Query
  onSuccess?: (data: Response) => void
}

export const conversationQuestionsQuery = ({ query, onSuccess }: Props = {}) => {
  return queryOptions({
    queryKey: getConversationQuestionsQueryKey(query),
    queryFn: async () => {
      const response = await axios.get<Response>("/support/questions", { params: query })

      onSuccess?.(response.data)

      return response.data.data
    },
  })
}
